import { BTooltip } from "bootstrap-vue";
import Back from "@@/core/components/shared/Back/Back";
import {
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";

export default {
  name: "OrderHeader",
  components: {
    BTooltip,
    Back,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      trackingCode: null,
      password: null,
      type: null,
      amount: 0,
      admin: null,
    }
  },
  props: {
    order: Object,
  },
  mounted(){
    this.homeRequest();
  },
  methods: {
    refundOrder() {
      this.$emit("refundOrderEmiter");
    },
    async homeRequest(){
      const response = await this.$axios.get('admin/home');
      console.log(response.data.data);
      this.admin = response.data.data.admin;
      
    },
    orderEdit() {
      this.$emit("order-edit");
    },
    printOrder() {
      this.$emit("print-order");
    },
    async refundPost() {
      const data = {
        id: this.order.id,
      };
      try {
        const response = await this.$axios.post('admin/orders-post-suspend', data);
        this.$root.notify(response.data.message, 'success');
      } catch (error) {  
        this.$root.notify(error)
      }
    },
    async submitData() {
      const data = {
        tracking_code: this.trackingCode,
        amount: this.amount,
        password: this.password,
        type: this.type,
      };
      try {
        const response = await this.$axios.post('admin/manual-digipay-refund', data);
        this.$root.notify(response.data.message, 'success');
        this.isButtonDisabled = true;  
      } catch (error) {  
        this.$root.notify(error)
      }
    }
  },
};
